import LoadingSpinner from "components/LoadingSpinner";
import PopupMessage from "components/popup-message";
import AppConfigs from "configs/env";
import { SHOW_POPUP_REDIRECT_LOGIN } from "constants/common";
import eventEmitter from "help/eventEmitter";
import TheBanner from "layout/TheBanner/TheBanner";
import TheFooter from "layout/TheFooter";
import TheFooterInner from "layout/TheFooterInner/TheFooterInner";
import TheHeader from "layout/TheHeader";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import actions from "redux/home/actions";
import routes from "routes";

const TheRoutes = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");

  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const [nameBtn, setNameBtn] = useState("");

  const checkError = (errCode) => {
    let content = "";
    switch (errCode) {
      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu.
          Vui lòng quay trở lại vào ngày ${AppConfigs.startDate}`;

        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc vào ngày ${AppConfigs.endDate}. Hẹn gặp lại bạn trong các chương trình sau nhé.`;

        break;

      default:
        content = `Đã có lỗi xảy ra.<br/>
        Quý khách vui lòng thử lại sau.`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    showModal();
    setContent(`${content}`);
  };
  const dispatch = useDispatch();

  const getCampaignInfo = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_CAMPAIGN_INFO.request(
        {},
        (res) => {
          setIsLoading(false)
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data?.error?.code);
        }
      )
    );
  };
  useEffect(() => {
    // getCampaignInfo();
  }, []);
  console.log('isLoading', isLoading)
  return (
    <BrowserRouter>
     

      <TheHeader />
      <main>
        <TheBanner />
        {/* <LoadingSpinner isLoading={isLoading} /> */}
        <Routes>
          {routes.map((elm) => {
            return (
              <Route key={elm.path} path={elm.path} element={elm.element} />
            );
          })}
        </Routes>
      </main>
      <TheFooter />
      {/* {modal && (
        <PopupMessage nameBtn={nameBtn} setModal={setModal} content={content} />
      )} */}
    </BrowserRouter>
  );
};

export default TheRoutes;
